export default {
  RESIGN: "resign",
  FAIL: "fail",
  TRANSFER: "transfer",
  ABSOLUTORY: "absolutory",
  FINISHED: "finished",
  CANCELLED: "cancelled",
};
